module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SOCio2/CoverDesign.jpg?1684514596074",
      "alt": "This image is the cover for the book Just for Nice, States of Love"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Just for Nice, States of Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Nick Caratelli flees the city in an attempt to escape a broken relationship and a career he never wanted. He plans to set up a bed-and-breakfast in the heart of Pennsylvania Dutch country—despite the fact he has no experience in renovating the old building. Luckily his handsome neighbor Sam approaches him with a curious proposal: he’ll help with the restoration in exchange for Nick babysitting his niece.")]), _vm._v(" "), _c('p', [_vm._v("As they work to have the bed-and-breakfast open for business by summer’s end, their lives become interwoven without them even trying. Before he knows it, Nick is recovering from his loss and taking his place in the unconventional family that seems determined to form. But for Nick and Sam to be together in all the ways they desire, they’ll have to realize all the arguments against romance exist only in their heads….")]), _c('p', [_c('b', [_vm._v("States of Love: ")]), _vm._v("Stories of romance that span every corner of the United States.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      H.M. Shepherd\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0